<script>
  import Footer from "@retailer/svelte/LimitedOrderingProductRequests/Footer.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Link from "@shared/svelte/Components/Link.svelte";
  import { restrictRepAccess } from "@retailer/services/preview_forbidden_flash";
  import SalesForceChat from "@shared/services/salesforce_chat";
  import { onMount } from "svelte";

  onMount(() => {
    SalesForceChat.initialize();
  });

  function startChat(event) {
    event.preventDefault();

    if (!restrictRepAccess()) {
      SalesForceChat.open();
    }
  }
</script>

<style>
  @media (min-width: 1440px) {
    .empty-product-requests-container {
      height: 80vh;
    }
  }
</style>

<main class="fizz-container-large fizz-justify-center empty-product-requests-container">
  <div class="fizz-inset-vertical-">
    <div class="fizz-inset-square-24">
      <Icon type={"Containers"} height={170} width={150} extraClassNames={"fizz-margin-auto"} />
      <h4
        class="fizz-heading-4 fizz-margin-auto fizz-flex-row fizz-justify-center fizz-stack-16 fizz-text-center"
      >
        No product requests
      </h4>
      <div class="fizz-margin-auto fizz-flex-row fizz-justify-center">
        <p
          class="fizz-text-center fizz-text-medium fizz-subdued"
          style="--max-width: 440px; max-width: var(--max-width);"
        >
          Have questions?
          <Link
            href="https://support.provi.com"
            title="Provi Support FAQ"
            style="color: #127ca5; font-weight: 700;"
          >
            Learn more
          </Link>
          about requests or
          <Link
            href="#"
            title="Chat"
            style="color: #127ca5; font-weight: 700;"
            on:click={startChat}
          >
            chat with support
          </Link>.
        </p>
      </div>
    </div>
  </div>
  <Footer />
</main>
